import React from 'react';
import { NCZIEntryItem } from '../../../../../Interfaces/ncziTypes';
import EHRCluster from './EHRCluster';
import EHRElement from './EHRElement';

interface Props {
	item: NCZIEntryItem | undefined;
}

const EHREntryItem: React.FC<Props> = props => {
	const { item } = props;

	if (item?.element) {
		return <EHRElement element={item.element} />;
	}

	if (item?.cluster) {
		return <EHRCluster cluster={item.cluster} />;
	}

	return <></>;
};

export default EHREntryItem;
